import type { CSSProperties } from "react";

const PARTICLES = [
  { x: 14, y: 19, size: 2, delay: "-3.4s", duration: "8s", drift: "-12px" },
  { x: 22, y: 72, size: 3, delay: "-6.8s", duration: "10s", drift: "10px" },
  { x: 31, y: 12, size: 2, delay: "-1.5s", duration: "9s", drift: "7px" },
  { x: 72, y: 14, size: 2, delay: "-5.2s", duration: "11s", drift: "-9px" },
  { x: 84, y: 31, size: 3, delay: "-2.1s", duration: "8.5s", drift: "11px" },
  { x: 89, y: 72, size: 2, delay: "-7.2s", duration: "10.5s", drift: "-10px" },
  { x: 68, y: 87, size: 2, delay: "-4.1s", duration: "9.5s", drift: "8px" },
  { x: 38, y: 89, size: 3, delay: "-0.8s", duration: "11.5s", drift: "-7px" },
  { x: 8, y: 51, size: 2, delay: "-5.8s", duration: "8.8s", drift: "9px" },
] as const;

/** Decorative-only layer. It never owns focus, pointer input, or launcher state. */
export function OrbitAtmosphere() {
  return (
    <div className="home-orbit-atmosphere" aria-hidden="true">
      <span className="home-orbit-aurora home-orbit-aurora--one" />
      <span className="home-orbit-aurora home-orbit-aurora--two" />
      <span className="home-orbit-horizon" />
      <div className="home-orbit-particles">
        {PARTICLES.map((particle, index) => (
          <span
            key={index}
            className="home-orbit-particle"
            style={
              {
                "--home-particle-x": `${particle.x}%`,
                "--home-particle-y": `${particle.y}%`,
                "--home-particle-size": `${particle.size}px`,
                "--home-particle-delay": particle.delay,
                "--home-particle-duration": particle.duration,
                "--home-particle-drift": particle.drift,
              } as CSSProperties
            }
          />
        ))}
      </div>
    </div>
  );
}
